import { render } from "./wait.vue?vue&type=template&id=31c3035b"
import script from "./wait.vue?vue&type=script&lang=js"
export * from "./wait.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Git\\Odendo\\MCB-mobile\\MCB.Sites.Mobile.CustomWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__